<style scoped></style>

<template>
  <v-btn
    v-if="template.price"
    @click="(event) => buyModel(event, template.staticId, template.uuid)"
    color="#ffd814"
    :small="size === 'small'"
    :x-small="size === 'x-small'"
  >
    <span
      style="align-items: center; display: flex;"
      :style="$store.state.buyingGS ? { opacity: 0 } : { opacity: 1 }"
    >
      Buy for ${{template.price}}
    </span>

    <span
      class="custom-loader"
      :style="$store.state.buyingGS ? { opacity: 1 } : { opacity: 0 }"
    >
      <v-icon style="font-size: 16px;">mdi-sync</v-icon>
    </span>
  </v-btn>
</template>

<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'BuyBtn',
  props: {
    template: {},
    size: String,
  },
  mixins: [Mixin],
  methods: {
    buyModel(event, staticId, uuid) {
      event.stopPropagation();
      this.$store.dispatch('buyModel', {
        staticId,
        uuid,
      });
    },
  },
};
</script>
